// src/components/common/Navbar.js - Reusable navigation bar
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUser, clearAuth, isAdmin, isJournalist } from '../../utils/auth';
import ThemeSwitcher from './ThemeSwitcher';
import LanguageSwitcher from './LanguageSwitcher';

const Navbar = ({ showHome = true }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const user = getUser();
  const isAuthenticated = !!user;

  const handleLogout = () => {
    clearAuth();
    navigate('/login');
  };

  return (
    <header className="bg-white dark:bg-shayek-dark shadow-sm border-b border-shayek-light-300 dark:border-shayek-dark-200 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Left side - Logo/Title */}
          <div className="flex items-center gap-4">
            {showHome ? (
              <Link to="/" className="flex items-center">
                <img
                  src="/logo-chayyek.png"
                  alt={t('common.appName') || 'Chayyek AI'}
                  className="h-16 md:h-20 w-auto"
                />
              </Link>
            ) : (
              <img
                src="/logo-chayyek.png"
                alt={t('common.appName') || 'Chayyek AI'}
                className="h-16 md:h-20 w-auto"
              />
            )}
          </div>

          {/* Right side - Navigation and controls */}
          <div className="flex items-center gap-4">
            <ThemeSwitcher />
            <LanguageSwitcher />
            <a
              href="https://www.chayyek.com/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-medium text-[#751F19] dark:text-[#6C5723] hover:opacity-80 transition-opacity"
            >
              Go to Chayyek | انتقل لشييك
            </a>
            {isAuthenticated ? (
              <>
                <Link
                  to="/dashboard"
                  className="px-4 py-2 text-sm text-shayek-light-700 dark:text-shayek-dark-700 bg-shayek-light-100 dark:bg-shayek-dark-100 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-50 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
                >
                  {t('navbar.dashboard') || 'Dashboard'}
                </Link>
                
                {isAdmin() && (
                  <Link
                    to="/admin"
                    className="px-4 py-2 text-sm text-shayek-light-700 dark:text-shayek-dark-700 bg-shayek-light-100 dark:bg-shayek-dark-100 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-50 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
                  >
                    {t('navbar.admin') || 'Admin'}
                  </Link>
                )}
                
                {isJournalist() && (
                  <Link
                    to="/journalist"
                    className="px-4 py-2 text-sm text-shayek-light-700 dark:text-shayek-dark-700 bg-shayek-light-100 dark:bg-shayek-dark-100 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-50 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
                  >
                    {t('navbar.journalist') || 'Team Chayyek'}
                  </Link>
                )}
                
                <Link
                  to="/profile"
                  className="px-4 py-2 text-sm text-shayek-light-700 dark:text-shayek-dark-700 bg-shayek-light-100 dark:bg-shayek-dark-100 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-50 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
                >
                  {t('navbar.profile') || 'Profile'}
                </Link>
                
                <span className="text-sm text-shayek-light-600 dark:text-shayek-dark-600 hidden sm:inline">
                  {user?.email}
                </span>
                
                <button
                  onClick={handleLogout}
                  className="px-4 py-2 text-sm text-white bg-shayek-primary dark:bg-shayek-primary-600 rounded-lg hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light transition-colors"
                >
                  {t('navbar.logout') || 'Logout'}
                </button>
              </>
            ) : (
              <>
                <Link
                  to="/login"
                  className="px-4 py-2 text-sm text-shayek-light-700 dark:text-shayek-dark-700 bg-shayek-light-100 dark:bg-shayek-dark-100 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-50 transition-colors border border-shayek-light-300 dark:border-shayek-dark-200"
                >
                  {t('navbar.login') || 'Login'}
                </Link>
                <Link
                  to="/register"
                  className="px-4 py-2 text-sm text-white bg-shayek-primary dark:bg-shayek-primary-600 rounded-lg hover:bg-shayek-primary-600 dark:hover:bg-shayek-red-light transition-colors"
                >
                  {t('navbar.register') || 'Register'}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;

